var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircledMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.75,
    cy: 11,
    r: 1.75,
    fill: "#1C3177"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.75,
    cy: 18,
    r: 1.75,
    fill: "#1C3177"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.75,
    cy: 25,
    r: 1.75,
    fill: "#1C3177"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 11,
    r: 1.75,
    fill: "#1C3177"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 1.75,
    fill: "#1C3177"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 25,
    r: 1.75,
    fill: "#1C3177"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.25,
    cy: 11,
    r: 1.75,
    fill: "#1C3177"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.25,
    cy: 18,
    r: 1.75,
    fill: "#1C3177"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.25,
    cy: 25,
    r: 1.75,
    fill: "#1C3177"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledMenu);
export default __webpack_public_path__ + "static/media/Circled Menu.da0900710ee2ea11f704aa510d6cf1ba.svg";
export { ForwardRef as ReactComponent };